// Pure helpers for the Risk overview: the verdict in words, why a problem ranks high, and the severity bars.
export const SEVERITIES = ['critical', 'high', 'medium', 'low', 'info'];
export const GRADE = {
  A: { word: 'In good shape', color: '#22c55e' }, B: { word: 'Good', color: '#4ade80' }, C: { word: 'Fair', color: '#fcd34d' },
  D: { word: 'Needs work', color: '#fb923c' }, F: { word: 'Urgent', color: '#ef4444' }
};
export const gradeOf = (g) => GRADE[g] || GRADE.C;

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
export function sentence(data) {
  const open = data?.summary?.open_findings || 0;
  if (!open) return 'Nothing is open. Run a scan to keep this up to date.';
  const crit = data.severity.critical || 0;
  const wild = data.summary.exploited_cve_hits || 0;
  return `${plural(open, 'problem is', 'problems are')} open. ${crit ? `${crit} ${crit === 1 ? 'is' : 'are'} critical` : 'None is critical'}${wild ? ` and ${wild} ${wild === 1 ? 'is' : 'are'} being exploited in the wild right now` : ''}.`;
}

// Why a problem is near the top, in plain words.
export function whyChips(item) {
  const chips = [];
  if (item.kev_hit) chips.push({ label: 'Exploited in the wild', hot: true });
  if (item.epss >= 0.5) chips.push({ label: 'Likely to be attacked soon', hot: true });
  if (item.asset_criticality === 'critical' || item.asset_criticality === 'high') chips.push({ label: 'Important website' });
  if (item.confidence === 'high') chips.push({ label: 'Confirmed' });
  return chips;
}

export const severityBars = (severity) => {
  const total = SEVERITIES.reduce((n, s) => n + (severity?.[s] || 0), 0);
  return SEVERITIES.map((s) => ({ id: s, n: severity?.[s] || 0, pct: total ? Math.round(((severity?.[s] || 0) / total) * 100) : 0 }));
};
